import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/system';
import React, { ReactNode } from 'react';
import zeplinColor from 'theme/Color';

type CustomButtonType = {
  variant: 'text' | 'contained' | 'outlined';
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'customDisable'
    | 'customSecondary';
  text: string | ReactNode;
  style?: React.CSSProperties | SxProps<Theme> | undefined;
  textStyle?: React.CSSProperties | SxProps<Theme> | undefined;
  icon?: ReactNode;
  iconPosition?: 'start' | 'end';
  onClick: any;
  disabled: boolean;
  tabindex?: number;
  buttonVariant?:
    | 'buttonSmall'
    | 'buttonMedium'
    | 'buttonLarge'
    | 'responsiveButtonLarge'
    | 'responsiveButtonMedium';
};

const CustomButton = ({
  variant,
  color,
  text,
  style,
  textStyle,
  icon,
  iconPosition,
  onClick,
  disabled,
  tabindex,
  buttonVariant = 'buttonMedium',
}: CustomButtonType) => {
  return (
    <Button
      variant={variant}
      color={color}
      sx={
        style
          ? { ...style }
          : {
              '&.Mui-focusVisible': { backgroundColor: zeplinColor.Brand1Hover },
            }
      }
      startIcon={iconPosition === 'start' && icon}
      endIcon={iconPosition === 'end' && icon}
      disableRipple
      disableElevation
      onClick={onClick}
      disabled={disabled}
      tabIndex={tabindex}
    >
      <Typography variant={buttonVariant} sx={textStyle ? { ...textStyle } : {}}>
        {text}
      </Typography>
    </Button>
  );
};

export default CustomButton;
